<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <FieldsetFixedAssetGeneral
    :fixedAsset="fixedAsset"
    :labelAlign="labelAlign"
    v-if="!target || target === 'general'"
  >
  </FieldsetFixedAssetGeneral>
  <FieldsetFixedAssetWasteBin
    :fixedAsset="fixedAsset"
    :labelAlign="labelAlign"
    v-if="target === 'wasteBin'"
  >
  </FieldsetFixedAssetWasteBin>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class MFixedAssetEditorFieldset extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  fixedAsset!: object;

  @Watch('fixedAsset')
  onFixed_asset(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("fixedAsset")
  }

  @Prop({
    type: String,
  })
  target!: string;

  @Watch('target')
  onTarget(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("target")
  }

  labelAlign!: any;
  ux!: any;
  dataMembers = ['labelAlign', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        labelAlign: "right",
        ux: null,
      },
    }
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_1930: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_1929: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_1930 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_1929 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_1930,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_1929],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_1930,
      evh_7315092382398562_reload_1929,
      evh_7315092382398562_reload,
    }
  }
}

Vue.component("MFixedAssetEditorFieldset", MFixedAssetEditorFieldset);

</script>